import { render, staticRenderFns } from "./AllFormsAcademic.html?vue&type=template&id=ce8da1ea&scoped=true&"
import script from "./AllFormsAcademic.vue?vue&type=script&lang=js&"
export * from "./AllFormsAcademic.vue?vue&type=script&lang=js&"
import style0 from "./AllFormsAcademic.scss?vue&type=style&index=0&id=ce8da1ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8da1ea",
  null
  
)

export default component.exports